import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import { type SxProps, Typography, useTheme } from "@mui/material";
import type { Theme } from "@mui/material";
import { StyledToggleButton, StyledToggleButtonGroup } from "./styles";

export enum DifficultyCoachingLevel {
  DIFFICULTIES = "difficulties",
  NO_DIFFICULTIES = "noDifficulties",
  NOT_TREATED = "notTreated",
}

interface IDifficultyToggleGroupProps {
  value: DifficultyCoachingLevel | null;
  onChange: (newValue: DifficultyCoachingLevel | null) => void;
  color?: Record<DifficultyCoachingLevel, string>;
  sx?: SxProps<Theme>;
}

export const DifficultyToggleGroup = ({ value, onChange, color, sx }: IDifficultyToggleGroupProps) => {
  const theme = useTheme();

  const defaultColor = {
    difficulties: theme.palette.blue.main,
    noDifficulties: theme.palette.success.main,
    notTreated: theme.palette.gray.dark,
  };

  const colorMap = color ?? defaultColor;

  return (
    <StyledToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, value) => {
        onChange(value);
      }}
      aria-label="niveau de difficulté de l'accompagnement"
      sx={sx}
    >
      <StyledToggleButton
        selectedColor={colorMap[DifficultyCoachingLevel.DIFFICULTIES]}
        value={DifficultyCoachingLevel.DIFFICULTIES}
        aria-label="difficultés"
      >
        <SentimentNeutralIcon />
        <Typography noWrap variant="body1SemiBold">
          Difficultés
        </Typography>
      </StyledToggleButton>
      <StyledToggleButton
        value={DifficultyCoachingLevel.NO_DIFFICULTIES}
        selectedColor={colorMap[DifficultyCoachingLevel.NO_DIFFICULTIES]}
        aria-label="pas de difficulté"
      >
        <SentimentSatisfiedAltIcon />
        <Typography noWrap variant="body1SemiBold">
          Pas de difficultés
        </Typography>
      </StyledToggleButton>
      <StyledToggleButton
        selectedColor={colorMap[DifficultyCoachingLevel.NOT_TREATED]}
        value={DifficultyCoachingLevel.NOT_TREATED}
        aria-label="non abordé"
      >
        <HelpOutlineIcon />
        <Typography noWrap variant="body1SemiBold">
          Non abordé
        </Typography>
      </StyledToggleButton>
    </StyledToggleButtonGroup>
  );
};
